import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-datalist",
  "use": "icon-datalist-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-datalist\"><defs><style type=\"text/css\"></style></defs><path d=\"M848 336H368c-26.5 0-48-21.5-48-48s21.5-48 48-48h480c26.5 0 48 21.5 48 48s-21.5 48-48 48zM848 560H368c-26.5 0-48-21.5-48-48s21.5-48 48-48h480c26.5 0 48 21.5 48 48s-21.5 48-48 48zM848 784H368c-26.5 0-48-21.5-48-48s21.5-48 48-48h480c26.5 0 48 21.5 48 48s-21.5 48-48 48z\" p-id=\"104382\" /><path d=\"M176 288m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"104383\" /><path d=\"M176 512m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"104384\" /><path d=\"M176 736m-48 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0Z\" p-id=\"104385\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/datalist.svg
// module id = boM3
// module chunks = 22